import React from "react";
import Alert from "@material-ui/lab/Alert";

export default function AlertPopUp(props) {
  return props.open ? (
    <Alert elevation={6} variant="filled" {...props}>
      {props.message}{" "}
    </Alert>
  ) : null;
}
